





























































































































































import Vue from 'vue';

import Axios from 'axios';

import { MDCTextField } from '@material/textfield';
import { MDCFormField } from '@material/form-field';
import { MDCCheckbox } from '@material/checkbox';
import { MDCRipple } from '@material/ripple';
import { MDCDialog } from '@material/dialog';
import { MDCSnackbar } from '@material/snackbar';

import { User } from '../../../libs/classes/user';
import { Area } from './authorizations.vue';

interface Data {
  user: User;
  dialogDelConf: any;
  confUpdatedSnackbar: any;

  restrictedPaths: Area[];
}

export default Vue.extend({
  data(): Data {
    return {
      user: new User({}),
      dialogDelConf: null,
      confUpdatedSnackbar: null,

      restrictedPaths: [],
    };
  },
  mounted() {
    Axios.get('/API/admin/getUser/' + this.$route.params.userID).then((resp) => {
      this.user = new User(resp.data);
    }).finally(() => {
      const textFields: any = document.querySelectorAll('.editZone .mdc-text-field');
      for (const elem of textFields) {
        const textField = new MDCTextField(elem);
      }

      const formFieldsElements: any = document.querySelectorAll('.editZone .mdc-form-field');
      for (const elem of formFieldsElements) {
        const checkBoxesElement: any = document.querySelector('.mdc-checkbox');
        const checkbox = new MDCCheckbox(elem);

        const formField = new MDCFormField(elem);
        formField.input = checkbox;
      }

      const buttonsElements: any = document.querySelectorAll('.editZone .mdc-button');
      for (const elem of buttonsElements) {
        const buttonRipple = new MDCRipple(elem);
      }
    });

    const v = this;

    Axios.get('/API/admin/restrictedAreas').then((resp) => {
      for (const restrictedArea of resp.data) {
        const area = new Area(restrictedArea);

        if (v.user.authorizedPathIDs === null) {
          v.user.authorizedPathIDs = [];
        }

        for (const path of v.user.authorizedPathIDs) {
          if (path === area.id) {
            area.active = true;
          }
        }

        v.restrictedPaths.push(area);
      }

      v.restrictedPaths.sort(v.orderAreas);
    });

    const dialog: any = document.getElementById('dialogDeleteConfirmation');
    this.dialogDelConf = new MDCDialog(dialog);

    const confUpdate: any = document.getElementById('confirmUserUpdated');
    this.confUpdatedSnackbar = new MDCSnackbar(confUpdate);
  },
  destroyed() {
    this.dialogDelConf.destroy();
    this.confUpdatedSnackbar.destroy();
  },
  methods: {
    orderAreas(a: Area, b: Area): number {
      if (a.path < b.path) {
        return -1;
      }
      if (a.path > b.path) {
        return 1;
      }
      return 0;
    },
    clickeckOnCheckbox(restrictedPath: Area) {
      const inputElem: any = document.getElementById(restrictedPath.id);

      if (this.user.authorizedPathIDs === null) {
        this.user.authorizedPathIDs = [];
      }

      if (inputElem.checked) {
        this.user.authorizedPathIDs.push(restrictedPath.id);
      } else {
        const index = this.user.authorizedPathIDs.indexOf(restrictedPath.id);
        if (index > -1) {
          this.user.authorizedPathIDs.splice(index, 1);
        }
      }
    },
    updateUser() {
      Axios.put('/API/admin/user/' + this.user.id, this.user).then(() => {
        this.confUpdatedSnackbar.open();
      }).catch((err) => {
        console.warn(err);
      });
    },
    deleteUser() {
      this.dialogDelConf.open();
    },
    deleteUserConf() {
      const vue = this;
      Axios.delete('/API/admin/user/' + this.user.id).then(() => {
        vue.$router.back();
      });
    },
  },
});
